import { render, staticRenderFns } from "./SelfBiographyEditorial.vue?vue&type=template&id=ccef752c&scoped=true"
import script from "./SelfBiographyEditorial.vue?vue&type=script&lang=js"
export * from "./SelfBiographyEditorial.vue?vue&type=script&lang=js"
import style0 from "./SelfBiographyEditorial.vue?vue&type=style&index=0&id=ccef752c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccef752c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
